<template>
  <b-card title="Delete Account" class="mt-5" style="width: 550px">
    <b-form onkeydown="return event.key != 'Enter'">
      <p class="pb-2 grey--text">
        Are you sure you want to permanently delete your account?
        <br />All details will be deleted.
      </p>

      <b-form-group
        id="input-group-password"
        label="Enter your current password to continue"
        label-for="input-password"
      >
        <b-form-input
          id="input-password"
          v-model="form.password"
          type="password"
          required
          placeholder="Enter password"
          :state="state.password"
          aria-describedby="input-password-feedback"
          @keyup.enter="generateToken"
        ></b-form-input>

        <b-form-invalid-feedback id="input-password-feedback">
          <!-- eslint-disable-next-line -->
          {{ errors.password }}
        </b-form-invalid-feedback>
      </b-form-group>

      <div class="d-flex justify-content-between">
        <b-button
          variant="outline-secondary"
          :to="{ name: 'user.settings-page', hash: '#account' }"
          >Cancel</b-button
        >
        <b-button
          variant="outline-danger"
          :disabled="loading"
          @click="generateToken"
        >
          <b-spinner small v-if="loading"></b-spinner>&nbsp;Delete
        </b-button>
      </div>
    </b-form>
  </b-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      verificationToken: state => state.auth.verificationToken
    })
  },

  data() {
    return {
      loading: false,
      form: {
        password: null
      },
      state: {
        password: null
      },
      errors: {
        password: null
      }
    }
  },

  methods: {
    ...mapActions({
      getVerificationToken: 'auth/getVerificationToken',
      deleteAccount: 'auth/deleteAccount'
    }),

    async generateToken() {
      this.loading = true
      await this.getVerificationToken({
        password: this.form.password
      })
        .then(() => {
          this.removeAccount()
        })
        .catch(error => {
          if (error.response.data) {
            this.state.password = false
            this.errors.password = error.response.data.message
          }
        })
      this.loading = false
    },

    async removeAccount() {
      this.loading = true
      await this.deleteAccount()
      this.loading = false
    }
  },

  watch: {
    'form.password'() {
      this.state.password = this.form.password.length !== 0
      this.errors.password = 'This field is required'
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  height: 36px;
  padding: 4px 32px;
}
</style>
